import dayjs from 'dayjs';

export const getMonths = (data) => {
  return data?.map((item) => {
    const date = dayjs(item.date);
    const monthName = date.format('MMMM');
    const capitalizedMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1);
    return {
      val: `${date.year()}-${date.month()}`,
      opt: `${capitalizedMonth} ${date.year()}`,
      consumption: item.consumption,
      date: item.date,
    };
  });
};

export const getYears = (data) => {
  return data?.map((item) => {
    const date = dayjs(item.date);
    return {
      val: date.year(),
      opt: String(date.year()),
      consumption: item.consumption,
      date: item.date,
    };
  });
};

export function getToDate(from) {
  if (!from) return null;

  const date = new Date(from);

  date.setMonth(date.getMonth() + 1);
  return date.toISOString().split('.')[0] + 'Z';
}
